var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProductTypes = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M42 8h-4a3 3 0 0 0-3 3v3h10v-3a3 3 0 0 0-3-3ZM35 69h10V45H35zM45 26H35v7h10z"
})), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M25 73.444c0 .307.249.556.556.556h29.15a.294.294 0 0 0 .294-.294A4.706 4.706 0 0 0 50.294 69h-20.85A4.444 4.444 0 0 0 25 73.444ZM11.7 14.36a1 1 0 0 1 .768-.36H52a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H12.468a1 1 0 0 1-.768-.36l-4.167-5a1 1 0 0 1 0-1.28z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 17h45M71 42H26M8 20h46M72 39H26M9 23h45M71 36H26"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M68.3 44.64a1 1 0 0 1-.768.36H28a1 1 0 0 1-1-1V34a1 1 0 0 1 1-1h39.532a1 1 0 0 1 .768.36l4.166 5a1 1 0 0 1 0 1.28z"
}))));
export default SvgProductTypes;